<template>
  <div>
    <div v-if="!ismark">
      <comment-header
        :fathertitle="fathertitle"
        :childtitle="childtitle"
        :path="path"
      >
      </comment-header>
      <a-button style="float:right;margin: -20px 10px 20px 0" @click="returnOld"> <a-icon type="retweet" /> 返回旧版本 </a-button>
      <div class="btngroup">
        <div>
          <a-button
            icon="arrow-left"
            style="margin-right: 10px"
            @click="backTier"
            v-show="pTierBtn || rTierBtn"
          ></a-button>
          <span>{{
            pname == "" && prname == "" && rname == ""
              ? ""
              : pname + prname + rname
          }}</span>
        </div>
        <div v-if="!isfiledocument">
          <a-button type="info" @click="checkAll">
                      {{ checkboxAllText }}
                    </a-button>
                    <a-button type="info" @click="checkDel"> 删除 </a-button>
                    <a-button type="info" @click="clearAll"> 清空 </a-button>
        </div>
        <div v-if="!isfiledocument" style="display:flex;width:380px;align-items:center">
          <a-select
            placeholder="请选择"
            default-value="0"
            v-model="queryParam.type"
          >
            <a-select-option value="0" key="0">-全部-</a-select-option>
            <a-select-option value="1" key="1">未标注</a-select-option>
            <a-select-option value="2" key="2">已标注</a-select-option>
          </a-select>
          <a-input-search
            style="margin-left: 16px"
            placeholder="请输入文件名"
            v-model="queryParam.name"
            @search="search"
          />
        </div>
        <div>
          <a-button
            style="margin-right: 10px"
            v-show="pTierBtn && prTierBtn"
            @click="addResource"
          >
            添加资源库
          </a-button>
          <a-button
            style="margin-right: 10px"
            v-show="pTierBtn"
            @click="editResourceName"
          >
            修改资源库名
          </a-button>
          <a-button
            style="margin-right: 10px"
            v-show="pTierBtn"
            @click="delResource"
          >
            删除资源库
          </a-button>
          <a-button
            style="margin-right: 10px"
            v-show="pTierBtn"
            @click="showdownloadModel"
          >
            下载压缩包
          </a-button>
          <a-button style="margin-right: 10px" @click="showDrawer"
            >下载任务</a-button
          >
          <a-button
            type="primary"
            @click="uploadValidata"
            v-show="!isfiledocument"
          >
            <a-icon type="upload" /> 上传资源
          </a-button>
        </div>
      </div>
      <div class="document">
        <div class="fileDocument" v-if="isfiledocument">
          <div
            :class="['singlefile', { singlefileborder: num == index }]"
            v-for="(item, index) in projectListData"
            :key="item.key"
            ref="singlefile"
            @click="fileclick(item, index)"
            @dblclick="dbfileclick(item, index)"
            :title="item.name"
          >
            <img :src="fileimg" alt="" />
            <p style="textalign: center">{{ item.name }}</p>
          </div>
        </div>
        <div class="lableDocument" v-if="!isfiledocument">
          <a-list
            :grid="{
              gutter: 4,
              column: 6,
              xs: 1,
              sm: 2,
              md: 3,
              lg: 3,
              xl: 4,
              xxl: 6,
            }"
            :loading="listLoading"
          >
            <a-checkbox-group
              style="width: 100%"
              @change="checkboxChange"
              v-model="checkedValueList"
            >
              <a-list-item
                :key="index"
                v-for="(item, index) in fileData"
                style="margin-top: 20px"
              >
                <a-card :hoverable="true" style="width: 250px; height: 300px">
                  <img
                    slot="cover"
                    :alt="item.fileName"
                    :width="item.imageWidth"
                    :height="item.imageHeight"
                    :src="buildFilePath(item.imagePath, item.thumbFileName)"
                    @click="viewerItem(item.fileId, item.imagePath,item.realHeight,item.realWidth)"
                  />
                  <template slot="actions" class="ant-card-actions">
                    <a-checkbox
                      :id="bindId(item.fileId)"
                      :value="item.fileId"
                    />
                    <a-icon
                      key="setting"
                      type="eye"
                      @click="viewerItem(item.fileId, item.imagePath,item.realHeight,item.realWidth)"
                    />
                    <a-icon
                      type="highlight"
                      key="mark"
                      @click="gomark(item.fileId, item.imagePath, index)"
                    />
                    <a-icon
                      key="close"
                      type="close"
                      @click="removeItem(item.fileId)"
                    />
                  </template>
                  <a-card-meta :title="item.fileName"> </a-card-meta>
                </a-card>
              </a-list-item>
            </a-checkbox-group>
          </a-list>
          <!-- </vue-scroll> -->
          <div class="page">
            <a-pagination
              v-model="current"
              :page-size-options="pageSizeOptions"
              :total="paging.totalRecords"
              :show-total="(total) => `共计 ${paging.totalRecords} 项`"
              show-size-changer
              :page-size="paging.pageSize"
              @showSizeChange="onShowSizeChange"
              @change="changePage"
            >
              <template slot="buildOptionText" slot-scope="props">
                <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                <span v-if="props.value === '50'">全部</span>
              </template>
            </a-pagination>
          </div>
        </div>

        <resource-edit-form
          ref="resourceEditForm"
          :title="title"
          :visible="visible"
          :loading="confirmLoading"
          :model="mdl"
          @cancel="handleCancel"
          @ok="handleOk"
        >
        </resource-edit-form>

        <a-modal
          title="下载选项"
          :visible="showdownload"
          :confirm-loading="downloadLoading"
          @ok="clickDownloadOk"
          @cancel="clickDownloadCancel"
          okText="确定"
          cancelText="取消"
          :bodyStyle="{}"
        >
          <div class="downloaditem">
            <span style="margin-right: 10px; margin-left: 85px">资源类型:</span
            ><a-checkbox-group
              v-model="form.resourcetype"
              :options="ResourceOptions"
            />
          </div>

          <!-- </a-form-model-item> -->
          <!-- <a-form-model-item label="是否压缩" prop="compress"> -->
          <div class="downloaditem">
            <span style="margin-right: 10px">是否压缩:</span>
            <a-radio-group v-model="form.compress" style="margin-right: -17px">
              <a-radio :value="1"> 是 </a-radio>
              <a-radio :value="2"> 否 </a-radio>
            </a-radio-group>
          </div>
        </a-modal>

        <a-drawer
          title="资源下载"
          placement="right"
          :closable="true"
          :visible="showDrawerbtn"
          :after-visible-change="afterVisibleChange"
          @close="onClose"
          :width="800"
        >
          <CheckTable
            :data="downloaddata"
            :total="checktableTotal"
            @changepage="changepage2"
          />
        </a-drawer>

        <uploader
          v-if="startUpload"
          :options="uploadOption"
          :file-status-text="statusText"
          :auto-start="true"
          class="uploader-example"
          ref="uploader"
          @file-added="onFileAdded"
          @file-success="onFileSuccess"
          @file-error="onFileError"
          @file-removed="fileRemoved"
          @complete="uploadComplete"
        >
          <a-button
            shape="circle"
            icon="close"
            style="float: right"
            @click="uploadValidata"
          ></a-button>
          <br />
          <br />
          <uploader-unsupport></uploader-unsupport>
          <uploader-drop>
            <uploader-btn :attrs="attrs" style="background-color: #67c13b"
              ><i class="el-icon-upload" style="margin-right: 5px"></i
              >上传文件</uploader-btn
            >
            <i style="margin-right: 5px"
              >{{ uploadFileCount }}/{{ fileCount }}</i
            >
            <!-- <uploader-btn :directory="true" style="background-color: #79bbff"
                          ><i class="el-icon-folder-add" style="margin-right: 5px"></i>上传文件夹</uploader-btn
                        > -->
          </uploader-drop>
          <uploader-list></uploader-list>
        </uploader>

        <image-preview
          ref="imagePreview"
          :title="imagePreview.title"
          :filePreviewShow="imagePreview.visible"
          @close="closePreview"
          :imgList="imagePreview.imageList"
          :size="imagePreview.size"
          :currentImg="imagePreview.currentImg"
        >
        </image-preview>
      </div>
    </div>
    <div v-if="ismark">
      <Mark
        :imgurl="imgurl"
        :Colorindex="Colorindex"
        :id="imgId"
        @changeismark="changemark"
        :filePathId="currentResourceId"
        :pageIndex="paging.pageIndex"
        :type="queryParam.type"
        :name="queryParam.name"
        :pageSize="paging.pageSize"
      />
    </div>
  </div>
</template>

<script>
import CommentHeader from "@components/header";
import * as projectManagement from "@api/projectManage";
import * as labelFile from "@api/label_file";
import ResourceEditForm from "./ResourceEditForm";
import CheckTable from "./CheckTable";
import { requestUrl } from "@utils/request_url";
import ImagePreview from "./ImagePreview";
import Mark from "@views/Label";
import fileimg from '@assets/imgs/file.png'
const ResourceOptions = [
  {
    label: "图片文件",
    value: "picture",
  },
  {
    label: "标注文件",
    value: "mark",
  },
];
export default {
  components: {
    CommentHeader,
    ResourceEditForm,
    CheckTable,
    ImagePreview,
    Mark,
  },
  data() {
    return {
      fileimg: fileimg,
      ismark: false,
      fathertitle: "训练管理",
      childtitle: "资源管理",
      path: "/train/project-list",
      projectListData: [],
      num: null,
      tier: "",
      isfiledocument: true,
      fileLableId: null,
      fileLableId2: null,
      pTierBtn: false,
      rTierBtn: false,
      visible: false,
      confirmLoading: false,
      mdl: null,
      title: "",
      pname: "",
      prname: "",
      rname: "",
      catalog: "",
      currentName: "",
      delFileId: null,
      prTierBtn: true,
      currentResourceId: null,
      showdownload: false,
      downloadLoading: false,
      ResourceOptions,
      form: {
        resourcetype: ["picture", "mark"],
        compress: 2,
        history: 1,
      },
      showDrawerbtn: false,
      downloaddata: [],
      checktableTotal: 0,
      startUpload: false,
      uploadOption: {
        target:
          requestUrl.replace("/api/", "") +
          "/zuul/api/train/rest/file/upload_resource",
        maxChunkRetries: 2,
        testChunks: false,
        fileParameterName: "file",
        chunkSize: 1024 * 1024 * 1024,
        simultaneousUploads: 3,
        query: {
          filePathId: 0,
        },
        headers: {
          // 'Authorization': token
        },
      },
      attrs: {
        accept: [".jpg", ".png", ".json", ".zip"],
      },
      statusText: {
        success: "上传成功",
        error: "上传失败",
        uploading: "上传中",
        paused: "暂停中",
        waiting: "等待中",
      },
      uploadFileCount: 0,
      fileCount: 0,
      errorfilelist: [], // 上传失败信息列表
      controllerErrorFileDialog: false,
      listLoading: false,
      imagePreview: {
        title: "图片预览",
        visible: false,
        imageList: [],
        currentImg: "",
        size:{}
      },
      checkedValueList: [],
      fileData: [],
      paging: {
        pageSize: 16,
        totalRecords: 1,
        pageIndex: 1,
      },
      pageSizeOptions: ["8", "16", "24", "32", "40", "48", "96"],
      current: 1,
      queryParam: {
        name: "",
        type: "0",
      },
      checkboxAllText: "全选",
    };
  },
  methods: {
    loadProjectData() {
      const self = this;
      projectManagement.getAllProject().then((res) => {
        self.projectListData = [];
        if (res.data !== undefined && res.data != null && res.data.length > 0) {
          self.projectListData = res.data;
          this.tier = "p";
        }
      });
    },
    afterVisibleChange(val) {
      console.log("visible", val);
    },
    fileclick(item, index) {
      this.num = index;
      this.currentName = item.name;
      this.currentResourceId = item.id;
      // singleFile.style.border = '1px solid black'
      // console.log(this.$refs.singleFile);
    },
    dbfileclick(item, index) {
      if (this.tier == "p") {
        labelFile.getLabelResourceList(item.id).then((res) => {
          this.projectListData = res.data.list;
          this.tier = "pr";
          this.fileLableId = item.id;
          this.num = null;
          this.pTierBtn = true;
          this.pname = item.name + "/";
          this.currentName = "";
          this.currentResourceId = null;
        });
      }
      if (this.tier == "pr") {
        labelFile.getLabelResourceList2(item.id).then((res) => {
          console.log(res.data);
          if (res.data.length == 0) {
            this.isfiledocument = false;
            this.tier = "r";
            this.pTierBtn = false;
            this.rTierBtn = true;
            this.prname = item.name;
            this.currentResourceId = item.id;
            this.loadData();
          } else {
            this.projectListData = res.data;
            this.fileLableId2 = item.id;
            this.tier = "r";
            this.pTierBtn = true;
            this.prTierBtn = false;
            console.log(this.pTierBtn);
            this.num = null;
            this.prname = item.name + "/";
            this.currentName = "";
            this.currentResourceId = null;
          }
        });
      }
      if (this.tier == "r") {
        labelFile.getLabelResourceList2(item.id).then((res) => {
          if (res.data.length == 0) {
            this.isfiledocument = false;
            this.tier = "mr";
            this.pTierBtn = false;
            this.rTierBtn = true;
            console.log(this.pTierBtn);
            this.rname = item.name;
            this.currentResourceId = item.id;
            this.loadData();
          } else {
            this.projectListData = res.data;
            this.tier = "mr";
            this.pTierBtn = true;
            this.prTierBtn = false;
            this.rname = item.name;
          }
        });
      }
    },
    backTier() {
      if (this.tier == "pr") {
        this.loadProjectData();
        this.num = null;
        this.pTierBtn = false;
        this.rTierBtn = false;
        this.pname = "";
      }
      if (this.tier == "r") {
        console.log(this.fileLableId);
        const that = this;
        labelFile.getLabelResourceList(that.fileLableId).then((res) => {
          this.projectListData = res.data.list;
          this.isfiledocument = true;
          this.tier = "pr";
          this.num = null;
          this.pTierBtn = true;
          this.prTierBtn = true;
          this.prname = "";
          this.currentResourceId = null;
          this.currentName = "";
        });
      }
      if (this.tier == "mr") {
        const that = this;
        labelFile.getLabelResourceList2(that.fileLableId2).then((res) => {
          this.projectListData = res.data;
          this.isfiledocument = true;
          this.tier = "r";
          this.num = null;
          this.pTierBtn = true;
          this.rname = "";
          this.currentResourceId = null;
          this.currentName = "";
        });
      }
    },
    handleCancel() {
      if (
        this.$refs !== undefined ||
        this.$refs.resourceEditForm.form !== undefined
      ) {
        this.$refs.resourceEditForm.form.resetFields();
      }
      this.visible = false;
    },
    handleOk() {
      const form = this.$refs.resourceEditForm.form;
      const self = this;
      form.validateFields((errors, values) => {
        if (!errors) {
          if (this.title == "添加资源库") {
            labelFile
              .addLabelResource({ ...values, projectId: this.fileLableId })
              .then((res) => {
                labelFile.getLabelResourceList(this.fileLableId).then((res) => {
                  this.projectListData = res.data.list;
                  this.visible = false;
                  this.$message.success("新增成功");
                });
              });
          }
          if (this.title == "更新资源库") {
            labelFile
              .updateLabelResourceName({
                ...values,
                id: self.currentResourceId,
              })
              .then((res) => {
                if (this.tier == "pr") {
                  labelFile
                    .getLabelResourceList(this.fileLableId)
                    .then((res) => {
                      this.projectListData = res.data.list;
                      this.visible = false;
                      this.$message.success("更新成功");
                    });
                }
                if (this.tier == "r") {
                  labelFile
                    .getLabelResourceList2(self.currentResourceId)
                    .then((res) => {
                      this.projectListData = res.data.list;
                      this.visible = false;
                      this.$message.success("更新成功");
                    });
                }
              });
          }
        }
      });
    },
    addResource() {
      this.visible = true;
      this.title = "添加资源库";
      this.mdl = {};
    },
    editResourceName() {
      if (
        (this.tier == "pr" && this.currentName != "") ||
        (this.tier == "r" && this.currentName != "")
      ) {
        this.visible = true;
        this.title = "更新资源库";
        this.mdl = {
          name: this.currentName,
        };
      } else {
        this.$message.warning("请选择资源节点");
      }
    },
    delResource() {
      const that = this;
      if (this.currentResourceId == null) {
        this.$message.warning("请选择资源节点");
      } else {
        this.$confirm({
          title: `你想要删除此资源吗?`,
          content: `当你点击确认按钮时, 自动更新列表`,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            labelFile
              .removeLabelResourceName({
                id: that.currentResourceId,
              })
              .then((res) => {
                if (that.tier == "pr") {
                  labelFile
                    .getLabelResourceList(that.fileLableId)
                    .then((res) => {
                      that.projectListData = res.data.list;
                      that.$message.success("删除成功");
                    });
                }
                if (that.tier == "r") {
                  labelFile
                    .getLabelResourceList2(that.currentResourceId)
                    .then((res) => {
                      that.projectListData = res.data.list;
                      that.$message.success("删除成功");
                    });
                }
              });
          },
        });
      }
    },
    clickDownloadOk() {
      this.showdownload = false;
      console.log(this.form);
      projectManagement
        .createDownload({ pathId: this.currentResourceId })
        .then((r) => {
          projectManagement
            .getDownload({ pageIndex: 1, pageSize: 10 })
            .then((res) => {
              this.showDrawerbtn = true;
              this.downloaddata = res.data.list;
              this.getDownloadmsg = setInterval(() => {
                this.getdownmsg();
              }, 1000);
            });
        });
    },
    clickDownloadCancel() {
      this.showdownload = false;
    },
    showdownloadModel() {
      if (this.currentResourceId != null) {
        const obj = {
          resourcetype: ["picture", "mark"],
          compress: 2,
          history: 1,
        };
        Object.assign(this.form, obj);
        this.showdownload = true;
      } else {
        this.$message.warning("请选择资源节点");
      }
    },
    onClose() {
      this.showDrawerbtn = false;
      clearInterval(this.getDownloadmsg);
      clearInterval(this.getDownloadmsg2);
    },
    showDrawer() {
      projectManagement
        .getDownload({ pageIndex: 1, pageSize: 10 })
        .then((res) => {
          this.showDrawerbtn = true;
          this.downloaddata = res.data.list;
          this.checktableTotal = res.data.totalRecords;
          if (this.getDownloadmsg == null) {
            this.getDownloadmsg2 = setInterval(() => {
              projectManagement
                .getDownload({ pageIndex: 1, pageSize: 10 })
                .then((res) => {
                  this.downloaddata = res.data.list;
                  this.checktableTotal = res.data.totalRecords;
                });
            }, 1000);
          }
        });
    },
    changepage2(currentpage) {
      clearInterval(this.getDownloadmsg);
      clearInterval(this.getDownloadmsg2);
      projectManagement
        .getDownload({ pageIndex: currentpage, pageSize: 10 })
        .then((res) => {
          this.downloaddata = res.data.list;
          this.getDownloadmsg = setInterval(() => {
            projectManagement
              .getDownload({ pageIndex: currentpage, pageSize: 10 })
              .then((res) => {
                this.downloaddata = res.data.list;
              });
          }, 1000);
        });
    },
    uploadValidata() {
      const self = this;
      if (this.startUpload) {
        if (this.uploadFileCount < this.fileCount) {
          // 未上传完 强制关闭
          this.$confirm({
            title: `资源还未上传完，您想强制关闭上传组件吗？`,
            content: `当你点击确认按钮时, 强制停止上传`,
            onOk() {
              return new Promise((resolve, reject) => {
                setTimeout(() => {
                  resolve();
                }, 500);
              })
                .then((res) => {
                  self.cancelUpload();
                  self.loadData();
                  self.startUpload = false;
                  self.uploadBtnTitle = "上传资源";
                })
                .catch(() => console.log("小猪，出错啦，休息会吧!"));
            },
            autoFocusButton: null,
          });
        } else {
          this.loadData();
          this.startUpload = false;
          this.uploadBtnTitle = "上传资源";
        }
      } else {
        if (this.currentResourceId == null) {
          this.$message.warning("请选择资源节点");
          return false;
        } else {
          this.uploadOption.query.filePathId = this.currentResourceId;
          this.startUpload = true;
          // this.uploadBtnTitle = "关闭上传";
          this.fileCount = 0;
          this.uploadFileCount = 0;
        }
      }
    },
    onFileAdded(file) {
      const file_type = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        file_type === "png" ||
        file_type === "jpg" ||
        file_type === "jpeg" ||
        file_type === "zip" ||
        file_type == "json";
      if (!extension) {
        const obj = {
          rootname: "无",
          name: file.name,
          errorinfo: "文件不是 " + this.uploadType + " 格式",
        };
        const arr = file.relativePath.split("/");
        if (arr.length > 1) {
          obj["rootname"] = arr[0];
        }
        this.errorfilelist.push(obj);
        file.ignored = true;
      } else {
        file.resume();
      }
      this.$nextTick(() => {
        this.fileCount = this.$refs["uploader"].files.length;
      });
      // if (this.errorfilelist.length !== 0) {
      //   this.controllerErrorFileDialog = true
      // }
    },
    onFileSuccess(rootFile, file, response, chunk) {
      const res = JSON.parse(response);
      if (res.code !== 10002) {
        const obj = {
          rootname: "无",
          name: file.name,
          errorinfo: res.message,
        };
        if (rootFile.isFolder === true) {
          obj["rootname"] = rootFile.name;
        }
        this.errorfilelist.push(obj);
        this.controllerErrorFileDialog = true;
      } else {
        this.$nextTick(() => {
          this.uploadFileCount++;
        });
      }
    },
    onFileError(rootFile, file, response, chunk) {
      const obj = {
        rootname: "无",
        name: file.name,
        errorinfo: "文件上传失败",
      };
      if (rootFile.isFolder === true) {
        obj["rootname"] = rootFile.name;
      }
      this.errorfilelist.push(obj);
      this.controllerErrorFileDialog = true;
    },
    fileRemoved(file) {
      this.$nextTick(() => {
        this.fileCount = this.$refs["uploader"].files.length;
      });
    },
    uploadComplete() {},
    clearcache() {
      this.errorfilelist = [];
      this.controllerErrorFileDialog = false;
      this.$refs.uploader.uploader.cancel();
    },
    // 取消上传
    cancelUpload() {
      // this.thirdDialog = false;
      this.clearcache();
    },
    loadData() {
      const self = this;
      self.listLoading = true;
      self.fileData = [];
      labelFile
        .getLabelFilePage({
          pageIndex: self.paging.pageIndex,
          pageSize: self.paging.pageSize,
          name: self.queryParam.name,
          type: self.queryParam.type,
          filePathId: self.currentResourceId,
        })
        .then((res) => {
          self.checkedValueList = [];
          self.checkAllStatus = false;
          self.checkboxAllText = "全选";

          if (
            res.data != undefined &&
            res.data != null &&
            res.data.list.length > 0
          ) {
            self.paging.totalRecords = res.data.totalRecords;
            for (let index = 0; index < res.data.list.length; index++) {
              const element = res.data.list[index];
              var w = element.imageWidth;
              var h = element.imageHeight;
              element.realHeight = h
              element.realWidth = w
              if (w > h) {
                if (w > 250) {
                  // var scale = w / 268
                  // element.imageWidth = 268 + 'px'
                  // element.imageHeight = h / scale + 'px'
                  const scale = w / h;
                  if (250 / scale > 200) {
                    element.imageHeight = 200 + "px";
                    element.imageWidth = 200 * scale + "px";
                  } else {
                    element.imageHeight = 250 / scale + "px";
                    element.imageWidth = 250 + "px";
                  }
                }
              } else {
                if (h > 200) {
                  const scale = h / 200;
                  element.imageHeight = 200 + "px";
                  element.imageWidth = w / scale + "px";
                }
              }

              self.fileData.push(element);
            }
          } else {
            self.paging.totalRecords = 0;
            self.paging.pageIndex = 1;
          }
          self.listLoading = false;
        });
    },
    checkboxChange(checkedValues) {
      console.log("checked = ", checkedValues);
    },
    buildFilePath(fileName, thumbFileName) {
      // var file = ''
      // if(thumbFileName != null){
      //   file = thumbFileName
      // }else {
      //   file = fileName
      // }
      var file = "";
      // file = fileName;
       file = fileName.replace(/#/g, '%23');
      var image = new Image();
      image.src = requestUrl + file;
      return requestUrl + file;
    },
    viewerItem(id, filePath,height,width) {
      this.imagePreview.imageList = [];
      this.imagePreview.imageList.push(requestUrl + filePath);
      this.imagePreview.visible = true;
      this.imagePreview.size.height = height
      this.imagePreview.size.width = width
    },
    bindId(id) {
      return "checkbox_" + id;
    },
    gomark(id, path, index) {
      this.Colorindex = index;
      this.imgId = id;
      this.ismark = true;
      this.imgurl = requestUrl + path;
      this.deliverfile();
    },
    deliverfile() {
      const self = this;
      labelFile
        .getLabelFilePage({
          pageIndex: self.paging.pageIndex,
          pageSize: self.paging.pageSize,
          name: self.queryParam.name,
          type: self.queryParam.type,
          filePathId: self.currentResourceId,
        })
        .then((res) => {
          this.passOnfile = res.data.list;
          console.log(this.passOnfile);
        });
    },
    removeItem(id) {
      const self = this;
      this.$confirm({
        title: `你想要删除此资源吗?`,
        content: `当你点击确认按钮时, 自动更新列表`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              labelFile.removeFile({ id: id }).then((r) => {
                self.paging.pageIndex = 1;
                self.loadData();
              });
            })
            .catch(() => console.log("小猪，出错啦，休息会吧!"));
        },
        autoFocusButton: null,
      });
    },
    onShowSizeChange(current, pageSize) {
      this.paging.pageSize = pageSize;
      this.loadData();
    },
    changePage(page, pageSize) {
      this.paging.pageIndex = page;
      this.loadData();
    },
    closePreview() {
      this.imagePreview.visible = false;
    },
    changemark(value) {
      this.ismark = !value
    },
    search() {
      if (this.currentResourceId == null) {
        this.$message.warning("请选择资源节点");
      } else {
        this.loadData();
      }
    },
    checkAll() {
      if (!this.checkAllStatus) {
        this.checkAllStatus = true;
        var ids = [];
        this.fileData.forEach((item, index, arr) => {
          ids.push(item.fileId);
        });
        this.checkedValueList = ids;
        this.checkboxAllText = "取消全选";
      } else {
        this.checkAllStatus = false;
        this.checkedValueList = [];
        this.checkboxAllText = "全选";
      }
    },
    checkDel() {
      if (this.checkedValueList.length == 0) {
        this.$message.warning("请选择需要删除的资源");
      } else {
        const self = this;
        this.$confirm({
          title: `你想要删除此选择的资源吗?`,
          content: `当你点击确认按钮时, 自动更新列表`,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            })
              .then((res) => {
                var ids = [];
                for (var i = 0; i < self.checkedValueList.length; i++) {
                  ids.push({
                    id: self.checkedValueList[i],
                  });
                }
                labelFile.removeFiles(ids).then((r) => {
                  self.paging.pageIndex = 1;
                  self.loadData();
                });
              })
              .catch(() => console.log("小猪，出错啦，休息会吧!"));
          },
          autoFocusButton: null,
        });
      }
    },
    clearAll() {
      if (this.currentResourceId == null) {
        this.$message.warning("请选择需要删除的资源节点");
      } else {
        const self = this;
        this.$confirm({
          title: `你想要清除此选择的资源列表吗?`,
          content: `当你点击确认按钮时, 自动更新列表`,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            })
              .then((res) => {
                labelFile
                  .clearAll({ filePathId: self.currentResourceId })
                  .then((r) => {
                    self.paging.pageIndex = 1;
                    self.loadData();
                  });
              })
              .catch(() => console.log("小猪，出错啦，休息会吧!"));
          },
          autoFocusButton: null,
        });
      }
    },
    returnOld(){
      this.$emit('returnback',true)
    }
  },
  mounted() {
    this.loadProjectData();
  },
};
</script>

<style lang="less" scoped>
.btngroup {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.document {
  width: 100%;
  // height: 800px;
  min-height: 800px;
  border: 1px solid #ccc;
  padding: 10px;
  .fileDocument {
    display: flex;
    flex-wrap: wrap;
    .singlefile {
      width: 100px;
      height: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid white;
      cursor: pointer;
      user-select: none;
      img {
        width: 50px;
        height: 50px;
      }
      p {
        width: 100%;
        height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
      }
    }
    .singlefileborder {
      border: 1px solid #99d1ff !important;
      background-color: #cce8ff !important;
    }
    .singlefile:hover {
      background-color: #cce8ff;
    }
  }
}

/deep/.ant-card-actions {
  bottom: 0px;
  position: absolute;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
  zoom: 1;
  width: 100%;
}
.page {
  text-align: right;
}
/deep/ .ant-card-cover {
  height: 200px;
  width: auto;
  justify-items: center;
  align-items: center;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.ant-card-cover img {
  border-radius: 2px 2px 0 0;
  width: auto;
  margin: 0 auto;
}

/deep/ .ant-card-meta-title {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 10;
  font-size: 8px;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
  text-align: center;
}

/deep/.ant-card-extra {
  float: right;
  margin-left: 0px;
  padding: 16px 0;
  color: rgba(0, 0, 0, 0.65);
  font-weight: normal;
  font-size: 14px;
}

.downloaditem {
  display: block;
  text-align: center;
  line-height: 32px;
}

.uploader-example {
  background-color: white;
  width: 600px;
  padding: 15px;
  margin: 0 auto 0;
  font-size: 14px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.9);
  z-index: 9999;
  top: 300px;
  left: 55%;
  position: fixed;
}
.uploader-example .uploader-btn {
  margin-right: 8px;
  color: #ffffff;
  border: #ffffff;
}
/deep/ .uploader-example .uploader-list {
  max-height: 300px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
  .uploader-file[status="uploading"] > .uploader-file-info {
    > .uploader-file-status > span > i {
      visibility: hidden;
    }
    > .uploader-file-status > span > em {
      visibility: hidden;
    }
  }
}
</style>